import { useTranslation } from 'react-i18next'

import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Stepper from '@mui/material/Stepper'

import { OrderStatus } from '@/core/models/order.model'

type OrderStatusStepperProps = {
  status: OrderStatus
}

const normalSteps = [
  OrderStatus.Pending,
  OrderStatus.Confirmed,
  OrderStatus.In_Progress,
  OrderStatus.Completed,
]

const terminalErrorStatuses = [OrderStatus.Refused, OrderStatus.Canceled, OrderStatus.No_Show, OrderStatus.Rescheduled]

// Map legacy statuses to stepper position
function getActiveStep(status: OrderStatus): number {
  switch (status) {
    case OrderStatus.Pending:
      return 0
    case OrderStatus.Accepted:
    case OrderStatus.Confirmed:
      return 1
    case OrderStatus.In_Progress:
    case OrderStatus.Consultation_Created:
      return 2
    case OrderStatus.Completed:
      return 3
    default:
      return 0
  }
}

export default function OrderStatusStepper(props: OrderStatusStepperProps) {
  const { status } = props
  const { t } = useTranslation()

  const isError = terminalErrorStatuses.includes(status)

  if (isError) {
    const errorStep = getActiveStep(status) || 1
    return (
      <Stepper activeStep={errorStep} alternativeLabel>
        <Step>
          <StepLabel>{t('page.appointments.status.Pending')}</StepLabel>
        </Step>
        <Step>
          <StepLabel error>{t(`page.appointments.status.${status}`)}</StepLabel>
        </Step>
      </Stepper>
    )
  }

  const activeStep = getActiveStep(status)

  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {normalSteps.map((step) => (
        <Step key={step}>
          <StepLabel>{t(`page.appointments.status.${step}`)}</StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}
